import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import getPreloadedState from './getPreloadedState';
import { useSelector, useDispatch } from 'react-redux';
import storageSession from 'redux-persist/lib/storage/session';
import { persistStore, persistReducer, createTransform } from 'redux-persist';

export type RootState = ReturnType<typeof rootReducer>;
export type PartialRootState = Partial<RootState>;

// Reset transient fields on rehydration (page refresh)
const clientCredentialsTransform = createTransform(
    (inboundState) => inboundState,
    (outboundState: any) => ({
        ...outboundState,
        searchQuery: '',
        cursor: 0,
    }),
    { whitelist: ['ClientCredentials'] }
);

const persistConfig = {
    key: 'root',
    storage: storageSession,
    blacklist: ['auth'],
    transforms: [clientCredentialsTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

export const persistor = persistStore(store);

export type AppStore = typeof store;
export type StoreDispatch = typeof store.dispatch;
export type StoreGetState = typeof store.getState;

export const useAppDispatch = useDispatch.withTypes<StoreDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export { getPreloadedState };